<div class="panelInfo">
    <div *ngIf="openedLicense?.id?true:false">
        <div class="flex">
            <div class="driver-images width48">
                <img [src]="openedLicense.license_file" (click)="showImage(openedLicense.license_file)">
            </div>
            <div class="width48">
                <table class="expandedTable">
                    <tr>
                        <td>Plate</td>
                        <td>{{ openedLicense.plaka }}</td>
                    </tr>
                    <tr>
                        <td>Name</td>
                        <td>{{ openedLicense.user.name }}</td>
                    </tr>
                    <tr>
                        <td>Surname</td>
                        <td>{{ openedLicense.user.surname }}</td>
                    </tr>
                    <tr>
                        <td>TCKN or Passport</td>
                        <td>{{ openedLicense.user.tckn }}</td>
                    </tr>
                    <tr>
                        <td>Phone Number</td>
                        <td>{{ openedLicense.user.phone_number }}</td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>{{ openedLicense.user.email }}</td>
                    </tr>
                    <tr>
                        <td>Brand</td>
                        <td>{{ openedLicense.brand }}</td>
                    </tr>
                    <tr>
                        <td>Model</td>
                        <td>{{ openedLicense.model }}</td>
                    </tr>
                    <tr>
                        <td>Year</td>
                        <td>{{ openedLicense.year }}</td>
                    </tr>
                    <tr>
                        <td>Price</td>
                        <td>{{ openedLicense.price }}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{{ openedLicense.status }}</td>
                    </tr>
                    <tr>
                        <td>Created At</td>
                        <td>{{ openedLicense.created_on }}</td>
                    </tr>

                </table>
            </div>
        </div>
        <!-- <div class="panel-buttons" *ngIf="openedLicense?.status == 'Waiting'"> -->
        <div class="panel-buttons" >
            <button mat-raised-button color="warn" (click)="panelReject(openedLicense.id)">Rejected</button>
            <button mat-raised-button color="primary" (click)="panelAccept(openedLicense.id)">Approved</button>

        </div>


    </div>

</div>